import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

const ContactGpiRepresentativeToBuyCredits = ({ gpiRepresentativeData }) => {
  const { parentAccountOwnerFullName, parentAccountOwnerEmail } = gpiRepresentativeData;

  return (
    <Dialog
      header="Buy Credits"
      dismissableMask={false}
      closable={false}
      blockScroll={true}
      visible={true}
      onHide={() => {}}
      position="center"
    >
      <p>Please contact your GPI representative to buy more Credits.</p>
      <p>Your GPI representative:</p>
      <p>Name: {`${parentAccountOwnerFullName}`}</p>
      <p>Email: {parentAccountOwnerEmail}</p>
      <div className="center">
        <Button
          type="button"
          className="p-button-primary"
          label="CONTACT GPI REPRESENTATIVE"
          onClick={() => {
            window.open(`mailto:${parentAccountOwnerEmail}`);
          }}
        />
      </div>
    </Dialog>
  );
};

export default ContactGpiRepresentativeToBuyCredits;
